import React from 'react'
import { Route } from 'react-router-dom'

import PickingMenu from './PickingMenu/PickingMenu'
import AreaSeparacao from './AreaSeparacao/AreaSeparacao'
import EquipeSeparacao from './EquipeSeparacao/EquipeSeparacao'
import PickingCodigoBarra from './PickingCodigoBarra/PickingCodigoBarra'
import PickingManual from './PickingManual/PickingManual'
import AssocEntrega from './AssocEntrega/AssocEntrega'
import AssocAreaSeparacao from './AssocAreaSeparacao/AssocAreaSeparacao'
import AssocEquipeSeparacao from './AssocEquipeSeparacao/AssocEquipeSeparacao'
import OcorrenciaEmpresa from './OcorrenciaEmpresa/OcorrenciaEmpresa'
import ResumoSeparacao from './ResumoSeparacao/ResumoSeparacao'
import ResumoSeparacaoManual from './ResumoSeparacaoManual/ResumoSeparacaoManual'
import PickingReconferencia from './PickingReconferencia/PickingReconferencia'
import ReconferenciaEtiqueta from './ReconferenciaEtiqueta/ReconferenciaEtiqueta'
import ReconferenciaEtiquetaResultado from './ReconferenciaEtiqueta/ReconferenciaEtiquetaResultado'

import { auth } from '../../../services/util/auth.service'
import AssocAreaSeparacaoExcel from './AssocAreaSeparacaoExcel/AssocAreaSeparacaoExcel'
import TagPallet from './TagPallet/TagPallet'
import HistoricoLeitura from './HistoricoLeitura/HistoricoLeitura'
import CargasPendentesParaPicking from './CargasPendentesParaPicking/CargasPendentesParaPicking'
import PickingMaisOpcoes from './PickingMaisOpcoes/PickingMaisOpcoes'
import AssocAreaPlacaPrevistaCarregamento from './AssocAreaPlacaPrevistaCarregamento/AssocAreaPlacaPrevistaCarregamento'
import ComparativoPicking from './ComparativoPicking/ComparativoPicking'
import HistoricoLeituraLote from './HistoricoLeituraLote/HistoricoLeituraLote'

export default function Picking() {
  return (
    <React.Fragment>
      <Route path="/main/picking/menu" render={() => auth(<PickingMenu />)} />
      <Route path="/main/picking/area-separacao" render={() => auth(<AreaSeparacao />, 95)} />
      <Route path="/main/picking/equipe-separacao" render={() => auth(<EquipeSeparacao />, 96)} />
      <Route path="/main/picking/codigo-barra" render={() => auth(<PickingCodigoBarra />, 97)} />
      <Route path="/main/picking/manual" render={() => auth(<PickingManual />, 98)} />
      <Route path="/main/picking/assoc-entrega" render={() => auth(<AssocEntrega />)} />
      <Route path="/main/picking/assoc-area" render={() => auth(<AssocAreaSeparacao />)} />
      <Route
        path="/main/picking/assoc-area-import-excel"
        render={() => auth(<AssocAreaSeparacaoExcel />)}
      />
      <Route
        path="/main/picking/assoc-area-placa-prevista-carregamento"
        render={() => auth(<AssocAreaPlacaPrevistaCarregamento />)}
      />
      <Route path="/main/picking/assoc-equipe" render={() => auth(<AssocEquipeSeparacao />, 97)} />
      <Route
        path="/main/picking/ocorrencia-empresa"
        render={() => auth(<OcorrenciaEmpresa />, 99)}
      />
      <Route path="/main/picking/resumo-separacao" render={() => auth(<ResumoSeparacao />, 97)} />
      <Route
        path="/main/picking/resumo-separacao-manual"
        render={() => auth(<ResumoSeparacaoManual />, 98)}
      />
      <Route path="/main/picking/tag-pallet" render={() => auth(<TagPallet />)} />
      <Route path="/main/picking/historico-leitura" render={() => auth(<HistoricoLeitura />)} />
      <Route
        path="/main/picking/cargas-pendentes-para-picking"
        render={() => auth(<CargasPendentesParaPicking />, 100)}
      />
      <Route
        path="/main/picking/picking-mais-opcoes"
        render={() => auth(<PickingMaisOpcoes />, 97)}
      />
      <Route
        path="/main/picking/comparativo-picking"
        render={() => auth(<ComparativoPicking />, 97)}
      />
      <Route
        path="/main/picking/historico-leitura-periodo-lote"
        render={() => auth(<HistoricoLeituraLote />, 101)}
      />
      <Route
        path="/main/picking/reconferencia"
        render={() => auth(<PickingReconferencia />, 102)}
      />
      <Route
        path="/main/picking/reconferencia-etiqueta"
        exact
        render={() => auth(<ReconferenciaEtiqueta />, 134)}
      />
      <Route
        path="/main/picking/reconferencia-etiqueta/resultado"
        render={() => auth(<ReconferenciaEtiquetaResultado />, 134)}
      />
    </React.Fragment>
  )
}
